export const UPDATE_CARDS_LIST = 'UPDATE_CARDS_LIST'
export const DO_SEARCH = 'DO_SEARCH'
export const SEARCH_RESULTS = 'SEARCH_RESULTS'
export const SEARCH_ERROR = 'SEARCH_ERROR'
